function updateRgbVar(key, scope = document.documentElement) {
  const colorVar = `--${key}-color`;
  const rgbVar = `--${key}-rgb`;

  const value = getComputedStyle(scope)
    .getPropertyValue(colorVar)
    .trim();

  if (!value) return;
  const temp = document.createElement('div');
  temp.style.color = value;
  document.body.appendChild(temp);

  const computed = getComputedStyle(temp).color;
  document.body.removeChild(temp);

  const match = computed.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
  if (!match) return;

  const [, r, g, b] = match;

  scope.style.setProperty(rgbVar, `${r}, ${g}, ${b}`);
}

function updateColorVar(key, colorValue, scope = document.documentElement) {
  const colorVar = `--${key}-color`;
  document.documentElement.style.setProperty(colorVar, colorValue);
  updateRgbVar(key);
}

export { updateColorVar };

export default updateColorVar;
